$(window).on('load', function () {
  // Remove the spinner.
  $('.boutiques_spinner_v1_target').fadeOut();

  // Handle linking to specific sections
  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // Handle links...?mod[num]=boutique_mod[num]
  function scrollToLinkMod(linkNo) {
    if (getParameterByName('mod' + linkNo) === 'boutique_mod' + linkNo) {
      $('html, body')
        .delay(500)
        .animate(
          {
            scrollTop: $('#r4_mod' + linkNo).offset().top - 100
          },
          1500,
          'easeInOutQuad'
        );
    }
  }

  for (i = 2; i <= 8; i++) {
    scrollToLinkMod(i);
  }

  // Handle the hero text fade-in
  $('#r4_hero_h1').css({
    opacity: '0',
    top: '13.85%'
  });
  $('#r4_hero_h2_1').css({
    opacity: '0',
    top: '29.95%'
  });
  $('#r4_hero_h2_2').css({
    opacity: '0',
    top: '33.85%'
  });
  $('#r4_hero_block_1').css({
    opacity: '0',
    top: '41.35%'
  });
  $('#r4_hero_block_2').css({
    opacity: '0',
    top: '54.85%'
  });
  $('#r4_hero_block_3').css({
    opacity: '0',
    top: '68.45%'
  });

  $('#r4_hero_h1').delay(250).animate(
    {
      opacity: 1,
      top: '9.85%'
    },
    420
  );
  $('#r4_hero_h2_1').delay(450).animate(
    {
      opacity: 1,
      top: '25.95%'
    },
    420
  );
  $('#r4_hero_h2_2').delay(650).animate(
    {
      opacity: 1,
      top: '29.85%'
    },
    420
  );
  $('#r4_hero_block_1').delay(850).animate(
    {
      opacity: 1,
      top: '37.35%'
    },
    420
  );
  $('#r4_hero_block_2').delay(1050).animate(
    {
      opacity: 1,
      top: '50.85%'
    },
    420
  );
  $('#r4_hero_block_3').delay(1250).animate(
    {
      opacity: 1,
      top: '64.45%'
    },
    420
  );
});

(function ($) {
  Drupal.behaviors.r4_formatter_v1 = {
    attach: function (context, settings) {
      $('.r4_formatter_v1', context).once('r4_formatter_v1', function () {
        /** SETUP **/
        // Apply classes
        function makeBoutiqueChecks() {
          // Check for Windows.
          if (navigator.platform == 'Win32') {
            $('body').addClass('isWin');
          }

          // Check for Safari.
          if (
            navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1
          ) {
            $('body').addClass('isSafari');
          }

          // Check for Firefox.
          var isFF = false;

          if (navigator.userAgent.search('Firefox') >= 0) {
            $('body').addClass('isFF');
            isFF = true;
          }

          // Check for IE.
          var isIE = false;

          if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
            isIE = true;
          }
          if (isIE) {
            if ($('body').hasClass('isTouch')) {
              $('body').removeClass('isTouch');
            }
          }

          // Check for mobile device
          var isMobile = false;

          if (
            /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
          ) {
            isMobile = true;
            $('body').addClass('isMobile');
          }

          // Check for iPad.
          var isTouch = false;

          if (navigator.userAgent.match(/iPad/i) != null) {
            isTouch = true;
            $('body').addClass('isTouch');
          }
        }
        makeBoutiqueChecks();

        /** ** SCROLLMAGIC FUNCTIONALITY ****/
        // /** MODULE 2 **/
        // // Reset elements
        // function resetMod2() {
        //   $("#r4_mod2").parent().css({
        //     'opacity': '0',
        //     'margin-top': '6%'
        //   });
        // }
        // resetMod2();

        // // Handle single play-through
        // var scene2FirstRun = true;

        // // Animation
        // function scene2() {
        //   if (scene2FirstRun) {
        //     $("#r4_mod2").parent().animate({
        //       opacity: 1,
        //       marginTop: "0",
        //     }, 600, "easeOutQuad", function () {
        //       scene2FirstRun = false;
        //     });
        //   } else {
        //     return;
        //   }
        // }

        // // Init scrollMagic Controller Class
        // var controllerTimeline2 = new ScrollMagic.Controller();

        // // Init scrollMagic Scene Class
        // var sceneTimeline2 = new ScrollMagic.Scene({
        //     triggerElement: "#r4_mod2",
        //     offset: -350
        //   })
        //   .on('start', function () {
        //     scene2();
        //   })
        //   .addTo(controllerTimeline2);

        /** MODULE 4 **/
        // Reset elements
        function resetMod4() {
          $('#r4_mod4').parent().css({
            opacity: '0',
            'margin-top': '6%'
          });
          $('.r4_mod4_slide1_section1').css({
            opacity: '0',
            'padding-top': '5%'
          });
        }
        resetMod4();

        // Handle single play-through
        var scene4FirstRun = true;

        // Animation
        function scene4() {
          if (scene4FirstRun) {
            setTimeout(function () {
              $('#r4_mod4 .el_boutique_carousel_pagination_dot_1').trigger('click');
            }, 600);
            $('#r4_mod4')
              .parent()
              .animate(
                {
                  opacity: 1,
                  marginTop: '0'
                },
                600,
                'easeOutQuad',
                function () {
                  scene4FirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline4 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline4 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod4',
          offset: -300
        })
          .on('start', function () {
            scene4();
          })
          .addTo(controllerTimeline4);

        /** MODULE 5 **/
        // Reset elements
        function resetMod5() {
          $('#r4_mod5').parent().css({
            opacity: '0',
            'margin-top': '6%'
          });
        }
        resetMod5();

        // Handle single play-through
        var scene5FirstRun = true;

        // Animation
        function scene5() {
          if (scene5FirstRun) {
            $('#r4_mod5')
              .parent()
              .animate(
                {
                  opacity: 1,
                  marginTop: '0'
                },
                600,
                'easeOutQuad',
                function () {
                  scene5FirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline5 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline5 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod5',
          offset: -300
        })
          .on('start', function () {
            scene5();
          })
          .addTo(controllerTimeline5);

        /** MODULE 6 **/
        // Reset elements
        function resetMod6() {
          $('#r4_mod6').parent().css({
            opacity: '0',
            'margin-top': '6%'
          });
        }
        resetMod6();

        // Handle single play-through
        var scene6FirstRun = true;

        // Animation
        function scene6() {
          if (scene6FirstRun) {
            $('#r4_mod6')
              .parent()
              .animate(
                {
                  opacity: 1,
                  marginTop: '0'
                },
                600,
                'easeOutQuad',
                function () {
                  scene6FirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline6 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline6 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod6',
          offset: -230
        })
          .on('start', function () {
            scene6();
          })
          .addTo(controllerTimeline6);

        /** MODULE 8 **/
        // Reset elements
        function resetMod8() {
          $('#r4_mod8').parent().css({
            opacity: '0',
            'margin-top': '6%'
          });
        }
        resetMod8();

        // Handle single play-through
        var scene8FirstRun = true;

        // Animation
        function scene8() {
          if (scene8FirstRun) {
            $('#r4_mod8')
              .parent()
              .animate(
                {
                  opacity: 1,
                  marginTop: '0'
                },
                600,
                'easeOutQuad',
                function () {
                  scene8FirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline8 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline8 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod8',
          offset: -280
        })
          .on('start', function () {
            scene8();
          })
          .addTo(controllerTimeline8);

        /** OLAPIC MODULE **/
        // Reset elements
        function resetMod9() {
          $('.olapic-widget.olapic-widget-v1').css({
            opacity: '0',
            'margin-top': '6%'
          });
        }
        resetMod9();

        // Handle single play-through
        var scene9FirstRun = true;

        // Animation
        function scene9() {
          if (scene9FirstRun) {
            $('.olapic-widget.olapic-widget-v1').animate(
              {
                opacity: 1,
                marginTop: '0'
              },
              600,
              'easeOutQuad',
              function () {
                scene9FirstRun = false;
              }
            );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline9 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline9 = new ScrollMagic.Scene({
          triggerElement: '.olapic-widget.olapic-widget-v1',
          offset: -300
        })
          .on('start', function () {
            scene9();
          })
          .addTo(controllerTimeline9);
        /** ** VIDEO FUNCTIONALITY ****/
        // Players.
        var player1, player2, player3;
        // Video sources.
        var src1 = 'Klmt6IQhVZQ';
        var src2 = 'ULOWCqrXJh4';
        var src3 = 'tYcZFbwVV-4';
        // Initialise YouTube API.
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];

        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Execute as soon as the player API is ready.
        onYouTubeIframeAPIReady = function () {
          player1 = new YT.Player('r4_mod2_video_container', {
            height: '390',
            width: '640',
            videoId: src1,
            playerVars: {
              autohide: 1,
              autoplay: 0,
              color: 'red',
              cc_load_policy: 0,
              controls: 0,
              disablekb: 0,
              end: 0,
              wmode: 'transparent',
              fs: 1,
              loop: 0,
              html5: 1,
              playsinline: 1
            },
            events: {
              onReady: playerOneReady,
              onStateChange: onPlayerStateChangeOne
            }
          });
          player2 = new YT.Player('r4_mod3_video_container', {
            height: '390',
            width: '640',
            videoId: src2,
            playerVars: {
              autohide: 1,
              autoplay: 0,
              color: 'red',
              cc_load_policy: 0,
              controls: 0,
              disablekb: 0,
              end: 0,
              wmode: 'transparent',
              fs: 1,
              loop: 0,
              html5: 1,
              playsinline: 1
            },
            events: {
              onReady: playerTwoReady,
              onStateChange: onPlayerStateChangeTwo
            }
          });
          player3 = new YT.Player('r4_mod7_video_container', {
            height: '390',
            width: '640',
            videoId: src3,
            playerVars: {
              autohide: 1,
              autoplay: 0,
              color: 'red',
              cc_load_policy: 0,
              controls: 0,
              disablekb: 0,
              end: 0,
              wmode: 'transparent',
              fs: 1,
              loop: 0,
              html5: 1,
              playsinline: 1
            },
            events: {
              onReady: playerThreeReady,
              onStateChange: onPlayerStateChangeThree
            }
          });
        };

        // When the Players are ready.
        var duration1, duration2, duration3;
        var videoInterval1, videoScrubber1;
        var videoInterval2, videoScrubber2;
        var videoInterval3, videoScrubber3;
        var close1 = $('#r4_mod2 .boutique__video_close_x');
        var close2 = $('#r4_mod3 .boutique__video_close_x');
        var close3 = $('#r4_mod7 .boutique__video_close_x');
        var playTrigger1 = $('#r4_mod2 .r4_video_tvc_play, #r4_mod2 .r4_video_tvc_cta'),
          playTrigger2 = $('#r4_mod3 #r4_mod3_slide3_play, #r4_mod3 #r4_mod3_slide3_cta'),
          playTrigger3 = $(
            '#r4_mod7 .r4_video_360_play, #r4_mod7 .r4_video_360_cta, .r4_video_360_parallax'
          );
        var playPauseBtn;

        function playerOneReady() {
          duration1 = player1.getDuration();
          videoInterval1, (videoScrubber1 = $('#r4_mod2_video .boutique__video_inner_scrubber'));
        }

        function playerTwoReady() {
          duration2 = player2.getDuration();
          videoInterval2, (videoScrubber2 = $('#r4_mod3_video .boutique__video_inner_scrubber'));
        }

        function playerThreeReady() {
          duration3 = player3.getDuration();
          videoInterval3, (videoScrubber3 = $('#r4_mod7_video .boutique__video_inner_scrubber'));
        }

        // Handle toggle of play/pause.
        function playPause(playerNum) {
          if (playPauseBtn.hasClass('active')) {
            playerNum.pauseVideo();
            playPauseBtn.removeClass('active');
          } else {
            playPauseBtn.addClass('active');
            playerNum.playVideo();
          }
        }

        // Toggle play/pause for first video.
        var playPauseBtn1 = $('#r4_mod2_video .boutique__video_play_btn');

        playPauseBtn1.on('click', function () {
          playPauseBtn = $(this);
          playPause(player1);
        });

        // Toggle play/pause for second video.
        var playPauseBtn2 = $('#r4_mod3_video .boutique__video_play_btn');

        playPauseBtn2.on('click', function () {
          playPauseBtn = $(this);
          playPause(player2);
        });

        // Toggle play/pause for third video.
        var playPauseBtn3 = $('#r4_mod7_video .boutique__video_play_btn');

        playPauseBtn3.on('click', function () {
          playPauseBtn = $(this);
          playPause(player3);
        });

        function onPlayerStateChangeOne(event) {
          if (event.data == YT.PlayerState.PLAYING) {
            playPauseBtn1.addClass('active');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playPauseBtn1.removeClass('active');
          }
        }

        function onPlayerStateChangeTwo(event) {
          if (event.data == YT.PlayerState.PLAYING) {
            playPauseBtn2.addClass('active');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playPauseBtn2.removeClass('active');
          }
        }

        function onPlayerStateChangeThree(event) {
          if (event.data == YT.PlayerState.PLAYING) {
            playPauseBtn3.addClass('active');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playPauseBtn3.removeClass('active');
          }
        }

        // Check for iPad.
        var isTouch = false;

        if (navigator.userAgent.match(/iPad/i) != null) {
          isTouch = true;
          $('body').addClass('isTouch');
        }

        // Check for IE.
        var isIE = false;

        if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
          isIE = true;
        }
        if (isIE) {
          if ($('body').hasClass('isTouch')) {
            $('body').removeClass('isTouch');
          }
        }

        // Play the videos.
        function playEach(
          theNum,
          eachPlayerNum,
          eachInterval,
          eachDuration,
          eachScrubber,
          eachClose,
          eachEnd,
          src
        ) {
          $('#r4_mod' + theNum + '_video .boutique__video_close_x').show();
          $('#r4_mod' + theNum + '_video .boutique__video_controls_mask').show();
          $('#r4_mod' + theNum + '_video').fadeIn();
          $('#r4_mod' + theNum + '_video .boutique__video_play_btn').addClass('active');
          $('#r4_mod' + theNum + '_video_container').show();

          if (isTouch && !isIE) {
            $('#r4_mod' + theNum + '_video .boutique__video_controls_mask').hide();
          }
          scrubberAndPlay(
            eachPlayerNum,
            eachInterval,
            eachDuration,
            eachScrubber,
            eachClose,
            eachEnd
          );
        }

        playTrigger1.click(function () {
          playEach(2, player1, videoInterval1, duration1, videoScrubber1, close1, 1, src1);
        });

        playTrigger2.click(function () {
          playEach(3, player2, videoInterval2, duration2, videoScrubber2, close2, 1, src2);
        });

        playTrigger3.click(function () {
          playEach(7, player3, videoInterval3, duration3, videoScrubber3, close3, 1, src3);
        });

        // Handle the scrubber.
        function scrubberAndPlay(playerNum, vidInterval, duration, vidScrubber, close, closeTime) {
          playerNum.seekTo(0, true);
          playerNum.playVideo();

          vidInterval = setInterval(function () {
            var currentTime = playerNum.getCurrentTime(),
              multipliedTime = (currentTime / duration) * 100 + 3;

            vidScrubber.css('width', multipliedTime + '%');
            if (currentTime >= duration - closeTime) {
              close.click();

              return;
            }
          }, 30);
        }

        // Handle fullscreen option.
        function checkFullscreen(fullscreenNo) {
          $('#r4_mod' + fullscreenNo + ' .boutique__video_full_btn').click(function () {
            screenfull.request($('#r4_mod' + fullscreenNo + '_video_container')[0]);
          });
        }

        function hideFullscreen(fullscreenNo) {
          $('#r4_mod' + fullscreenNo + ' .boutique__video_full_btn').hide();
        }

        if (screenfull.enabled) {
          checkFullscreen(2);
          checkFullscreen(3);
          checkFullscreen(7);
        } else {
          hideFullscreen(2);
          hideFullscreen(3);
          hideFullscreen(7);
        }

        // Close the videos.
        function closePlayer(whichPlayer, playerNum, whichInterval) {
          whichPlayer.pauseVideo();
          whichPlayer.stopVideo();
          $('#r4_mod' + playerNum + '_video_container').hide();
          $('#r4_mod' + playerNum + '_video .boutique__video_close_x').hide();
          $('#r4_mod' + playerNum + '_video .boutique__video_controls_mask').hide();
          $('#r4_mod' + playerNum + '_video .boutique__video_play_btn').removeClass('active');
          clearInterval(whichInterval);
          $('#r4_mod' + playerNum + ' .boutique__video_top_video').fadeOut();
        }

        close1.click(function () {
          closePlayer(player1, 2, videoInterval1);
        });

        close2.click(function () {
          closePlayer(player2, 3, videoInterval2);
        });

        close3.click(function () {
          closePlayer(player3, 7, videoInterval3);
        });
      });
    }
  };
})(jQuery);
